import { $log } from '../y/debug';
import { $location } from '../y/location';
import { UILink } from './elements';

export function uiParseLinkString(link: string): UILink {
    if(link.startsWith('/')) {
        return $location.urlToLocation(link);
    } else if(link.startsWith('#')) {
        return { target: link.substring(1) };
    } else if(link.startsWith('!')) {
        switch(link.substring(1)) {
            // case 'login': return { action: () => $tl.showLogin() };
            default: return { action: () => $log('app', 'unknown action link', link) };
        }
    } else {
        return { href: link };
    }
}
